import { AnalyticsPayload } from '../AnalyticsEvent';
import whatInput from 'what-input';

type InteractionDevice = 'initial' | 'pointer' | 'keyboard' | 'mouse' | 'touch';

const withInteraction = <T extends AnalyticsPayload>(
  payload: T
): T & { interactionDevice: InteractionDevice } => ({
  ...payload,
  interactionDevice: whatInput.ask()
});

export default withInteraction;
